<template>
  <div class="home flex-column">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('programs') }}</span>
        <span class="subtitle flex-row">{{ $t('select-a-program-to-continue') }}</span>
      </div>
    </div>
    <div class="content flex-row" v-if="domains !== 'empty'">
      <div class="selection-cf flex-column" v-for="domain in domains" :key="domain.domain">
        <div class="img-container flex-row">
          <img
            :src="getDialImage(domain.programGraphic)"
            alt="$t('coming-soon')"
            :class="['button-logo', domain.programGraphic]"
            @click="updateProgram(domain)"
          />
        </div>
        <span>{{ domain.name }} </span>
      </div>
    </div>
    <div v-if="domains === 'empty'">
      {{ $t('no-programs') }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Programs',
  components: {},
  data() {
    return {
      domains: null,
    };
  },
  methods: {
    updateProgram(program) {
      this.$store.state.global.programName = program.domain;
      this.$store.state.global.programStyle = program.lookAndFeel;
      this.$store.state.programBreadcrumb = program.breadCrumb;
      if (program.programGraphic) {
        this.$store.state.global.programImage = `${program.programGraphic}`;
      } else {
        this.$store.state.global.programImage = 'CFLogo';
      }
      if (this.$store.state.global.programName);
      this.$router.push({
        name: 'Dealer-List',
      });
      this.getNavPermissions(program);
      if (program.languages.length > 1) {
        this.updateLang(program.languages);
      }
    },
    updateLang(languages) {
      const newLanguages = [];
      languages.forEach((language) => {
        let languageObj = {};

        languageObj = {
          code: language.language.toLowerCase(),
          name: language.languageName,
        };
        newLanguages.push(languageObj);
      });
      if (newLanguages) {
        this.$store.dispatch('updateLanguages', newLanguages);
      }
    },
    getNavPermissions(program) {
      const loader = this.$loading.show();

      const { domain } = program;

      this.$store
        .dispatch('global/getNavPermissions', { domain })
        .then((res) => {
          this.$store.state.global.navPermissions = res;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    getDomains() {
      const loader = this.$loading.show();
      this.$store.state.surveyInterference = null;
      this.$store
        .dispatch('getDomains')
        .then((res) => {
          if (res && res.length > 0) {
            this.domains = res;

            const languages = [];
            this.domains.languages.forEach((language) => {
              let languageObj = {};

              languageObj = {
                code: language.language.toLowerCase(),
                name: language.languageName,
              };
              languages.push(languageObj);
            });
          } else {
            this.domains = 'empty';
          }
          loader.hide();
        })
        .catch(() => {
          loader.hide();
        });
    },
    getDialImage(image) {
      if (image) {
        if (image === 'CFLogo') {
          // eslint-disable-next-line import/no-dynamic-require
          return require(`@/assets/new/${image}.svg?external`);
        }
        // eslint-disable-next-line import/no-dynamic-require
        return require(`@/assets/new/${image} - Dark.png?external`);
      }
      return require('@/assets/new/CFLogo.png?external');
    },
    imageTypeCheck(url) {
      return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
    },
  },
  computed: {
    ...mapState('global', ['programName']),
  },
  created() {
    this.$store.state.activeFilters = null;
    this.getDomains();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
  }
}
.content {
  height: 100%;
  padding-left: 40px;
  flex-wrap: wrap;
  .selection-cf {
    flex-basis: calc(25% - 10px);
    margin-top: 40px;
    padding: 0 4px;
    overflow: hidden;
    align-items: center;
    .img-container {
      justify-content: center;
      align-items: center;
      padding: 10px 20px;
      max-width: 250px;
      min-width: 200px;
      box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.16);
      min-height: 100px;
      img {
        width: 200px;
      }
      .WagLogo {
        width: 200px !important;
      }
    }
    .button-logo {
      cursor: pointer;
    }
    span {
      margin-top: 20px;
      font-size: 20px;
      display: flex;
      justify-content: center;
      max-width: 250px;
      min-width: 200px;
    }
  }
}
.logo {
  vertical-align: middle;
  width: 400px;
  margin-top: 35px;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 30px 50px 30px 30px;
  justify-content: space-between;
}

::placeholder {
  color: black;
  opacity: 1;
}
.eyecon {
  width: 25px;
  cursor: pointer;
}
</style>
